import React from 'react';

interface IProps {
  data: string;
  onClickUpdate: () => void;
  title?: string;
  required?: boolean;
  error?: string;
  height?: number;
  disabled?: boolean;
  className?: string;
}
export const InputModal: React.FC<IProps> = ({
  data,
  onClickUpdate,
  title = '',
  required = false,
  error = '',
  height = 162,
  disabled = false,
  className,
}) => {
  return (
    <div className={className}>
      <p className="text-gray_800 mb-2 cursor-pointer typography-h6">
        {title} {required && <span className="text-error">*</span>}
      </p>
      <div className="relative p-3 border border-gray_300 rounded-md">
        <div
          className="overflow-scroll text-gray_800 text-wrap"
          style={{ minHeight: 80, maxHeight: height }}
          dangerouslySetInnerHTML={{
            __html: data,
          }}
        />
        {data ? (
          <span
            className={`text-blue absolute bg-white p-2 rounded flex typography-h6 items-center bottom-2 right-2 gap-1 ${
              disabled ? 'cursor-not-allowed' : 'cursor-pointer'
            }`}
            onClick={() => !disabled && onClickUpdate()}
          >
            Cập nhật
          </span>
        ) : (
          <b
            onClick={() => !disabled && onClickUpdate()}
            className={`text-main absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 cursor-pointer ${
              disabled ? 'cursor-not-allowed' : 'cursor-pointer'
            }`}
          >
            + Thêm mô tả
          </b>
        )}
      </div>
      {error && <span className="text-error fs-7">{error}</span>}
    </div>
  );
};
